// extracted by mini-css-extract-plugin
export var aboveInput = "_mo-0";
export var actionButton = "_mo-5";
export var actionButtonContainer = "_mo-1";
export var actionIcon = "_mo-6";
export var aiInfoContainer = "_mo-2";
export var attachmentWrapper = "_mo-7";
export var bold = "_mo-3";
export var checkIcon = "_mo-8";
export var clickingRecipientBar = "_mo-11";
export var commentThreadSwitch = "_mo-a";
export var draftImage = "_mo-b";
export var draftImageContainer = "_mo-c";
export var draftImages = "_mo-e";
export var editButton = "_mo-g";
export var editor = "_mo-f";
export var editorContainer = "_mo-y";
export var editorErrorTooltipWrapper = "_mo-9";
export var headerDivider = "_mo-h";
export var icon = "_mo-i";
export var info = "_mo-j";
export var internal = "_mo-n";
export var internalDivider = "_mo-k";
export var internalMessage = "_mo-l";
export var messageInputCard = "_mo-m";
export var messageInputForm = "_mo-o";
export var messageInputFormInternal = "_mo-p";
export var options = "_mo-q";
export var publicMessageCustomer = "_mo-s";
export var publicMessageMerchant = "_mo-r";
export var removeImageButton = "_mo-d";
export var replyButtons = "_mo-t";
export var showSignatureButton = "_mo-u";
export var spinner = "_mo-v";
export var verticalButtonDivider = "_mo-4";
export var visibilitySelector = "_mo-w";
export var warning = "_mo-x";
export var wrappingText = "_mo-z";
export var writingInternalNoteTopBorder = "_mo-10";